<template>
  <v-container fluid>
    <v-toolbar flat color="transparent" height="50">
      <h3 class="hidden-sm-and-down ml-0">Phân quyền</h3>
      <h4 class="hidden-md-and-up">Phân quyền</h4>
      <v-spacer></v-spacer>
      <v-btn color="green" @click="openDialogAddNewGroup" class="white--text">
        Thêm group
        <v-icon right dark>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="my-2 box-role">
      <v-layout row wrap>
        <v-flex xs5 sm4 md3>
          <v-tabs class="tabs-group" hide-slider>
            <h5 class="font-weight-medium ml-2 my-2">Group</h5>
            <v-tab
              class="text-xs-left"
              :class="{'tab-active' : selectedGroup && selectedGroup.id === group.id}"
              active-class="tab-active"
              v-for="group in groupRoles"
              :key="group.id"
              @click="changeTab(group)"
            >
              {{group.name}}
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs7 sm8 md9>
          <h5 class="font-weight-medium ml-3 my-2">Roles</h5>
          <v-list class="px-2">
            <template v-for="(role, index) in roles" >
              <v-list-tile :key="role.id">
                <v-list-tile-content>
                  <v-list-tile-title>{{role.displayName}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="selectedRoles" :value="role"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="index" class="my-2"></v-divider>
            </template>
          </v-list>
          <div class="text-xs-right">
            <v-btn color="primary" @click="updateGroupRole" :loading="loadingUpdate">Cập nhật</v-btn>
          </div>
        </v-flex>
      </v-layout>  
    </v-card>

    <dialog-add-new-group ref="addNewGroup" :roles="roles" @success="hanldeSuccess" />
  </v-container>
</template>    

<script>
import { mapActions } from 'vuex';
import DialogAddNewGroup from '../components/grouprole/DialogAddNewGroup';

export default {
  components: {
    DialogAddNewGroup
  },

  data: () => ({
    selectedGroup: null,
    selectedRoles: [],
    roles: [],
    groupRoles: [],
    loadingUpdate: false
  }),

  watch: {
    selectedRoles () {
      console.log('selectedRoles -> this.selectedRoles', this.selectedRoles);
    }
  },

  async created () {
    await this.getListRoles();
    await this.getListGroupRoles();
    this.changeTab(this.groupRoles[0]);
  },

  methods: {
    ...mapActions(['getRoles', 'getGroupRoles', 'addRoles', 'removeRoles']),
    async getListRoles () {
      let res = await this.getRoles();
      console.log('getDataRoles -> res', res);
      this.roles = res;
    },

    async getListGroupRoles () {
      let res = await this.getGroupRoles();
      this.groupRoles = res;
      console.log('getListGroupRoles -> this.groupRoles', this.groupRoles);
    },

    changeTab (group) {
      this.selectedGroup = group;
      this.selectedRoles = this.roles.filter(role =>
        group.roles.find(groupRole => groupRole === role.id)
      );
      console.log('changeTab -> this.selectedRoles', this.selectedRoles);
    },

    updateGroupRole () {
      let arrayAdd = this.selectedRoles.filter(
        role =>
          !this.selectedGroup.roles.find(groupRole => groupRole === role.id)
      );
      let arrayMove = this.selectedGroup.roles.filter(
        groupRole => !this.selectedRoles.find(role => role.id === groupRole)
      );

      if (!arrayAdd.length && !arrayMove.length) {
        window.getApp.showMessage('Group chưa có sự thay đổi', 'error');
        return;
      }

      let dataAddRole = {
        id: this.selectedGroup.id,
        roles: arrayAdd.map(item => item.id),
        remark: this.selectedGroup.remark
      };

      let dataRemoveRole = {
        id: this.selectedGroup.id,
        roles: arrayMove,
        remark: this.selectedGroup.remark
      };

      let addRole = this.addRoles(dataAddRole);
      let removeRole = this.removeRoles(dataRemoveRole);

      this.loadingUpdate = true;
      Promise.all([addRole, removeRole])
        .then(res => {
          this.getListGroupRoles();
          window.getApp.showMessage('Cập nhật thành công');
        })
        .catch(error => {
          window.getApp.showMessage('Cập nhật thất bại.', 'error');
        });
      this.loadingUpdate = false;
    },

    openDialogAddNewGroup () {
      this.$refs.addNewGroup.open();
    },

    hanldeSuccess (isSuccess) {
      if (isSuccess) {
        window.getApp.showMessage('Thêm group mới thành công!');
        this.getListGroupRoles();
      }
    }
  }
};
</script>

<style scoped>
.box-role >>> .layout {
  height: calc(100vh - 178px);
  overflow: hidden;
}
.box-role >>> .layout > .flex {
  height: 100%;
}
.box-role >>> .v-list {
  height: calc(100% - 88px);
  overflow: auto;
}
.box-role >>> .v-list__tile__title {
  white-space: normal;
  height: auto;
}
.box-role >>> .v-list__tile {
  height: auto;
}
.tabs-group {
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  height: 100%;
}
.tabs-group >>> .v-tabs__container {
  display: block;
  height: 100%;
  transform: translateX(0) !important;
  width: 100%;
}
.tabs-group >>> .v-tabs__div {
  display: block;
  max-width: 100%;
}
.tabs-group >>> .v-tabs__item {
  display: block;
}
.tabs-group .tab-active {
  color: #1976d2 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/GroupRole.vue